import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useReducer,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { officeApi } from "../../api/config";
import { AddPost } from "../../api/postapi";
import LookMagazine from "../../components/LookProject/LookMagazine";
import Interaction from "../../components/WriteProject/Interaction/Interaction";
import { MeetupReducer } from "../../interface/ActionReducer";
import { MagazineState } from "../../interface/initialState";
import { MagazineType } from "../../interface/interface";
import { MagazineBasicDataCHange, MagazineDataCHange } from "../../lib/lib";
import { RootState } from "../../reducers";
import { ToastChange } from "../../reducers/config";
import { LeaderInter } from "../../reducers/data";
import "./css/index.css";

type LocationType = {
  state:
    | {
        ctts_id: string;
        ctts_sts: string;
      }
    | undefined;
  pathname: string;
};

function WriteMagazine() {
  const rxPatch = useDispatch();
  const location = useLocation() as LocationType;
  const navigate = useNavigate();
  const path = location.pathname.split("/")[4];
  const leaderInfo = useSelector<RootState, LeaderInter>(
    (state) => state.data.leader
  );
  const [isLook, setIsLook] = useState<boolean>(false);
  const [state, dispatch] = useReducer(MeetupReducer, MagazineState);
  const [isError, setisError] = useState<boolean>(false);
  const Valid = useCallback(() => {
    const step = Number(path);
    const {
      title,
      mainimg,
      leader: { id, sub },
      category,
    } = state;

    if (step === 1) {
      return title && mainimg && category === "MGN_01"
        ? id && sub
        : sub
        ? true
        : false;
    } else {
      return true;
    }
  }, [state, path]);

  const UpdateCommon = useCallback(
    (
      type: string,
      payload: string | number | boolean,
      index: number | undefined
    ) => {
      dispatch({
        type,
        payload,
        index,
      });
    },
    [dispatch]
  );
  const PostMagazine = useCallback(
    (data: MagazineType) => {
      AddPost(
        location.state?.ctts_id
          ? Object.assign(
              {
                ctts_id: location.state.ctts_id,
                ctts_stat_cd: "ctts_sts_nrml",
              },
              data
            )
          : Object.assign({ ctts_stat_cd: "ctts_sts_nrml" }, data)
      ).then(({ state, msg }) => {
        if (state) {
          rxPatch(ToastChange({ active: true, content: msg }));
          navigate("/magazine/list");
        }
      });
    },
    [rxPatch, navigate]
  );
  const SaveMagazine = useCallback((data: MagazineType) => {
    // AddPost(
    //   location.state?.ctts_id
    //     ? Object.assign(
    //         {
    //           ctts_id: location.state.ctts_id,
    //           ctts_stat_cd: "ctts_sts_tmp",
    //           ctts_ctts: "asdkakslckla",
    //         },
    //         data
    //       )
    //     : Object.assign(
    //         { ctts_stat_cd: "ctts_sts_tmp", ctts_ctts: "asdkakslckla" },
    //         data
    //       )
    // ).then(({ state, msg }) => {
    //   if (state) {
    //     rxPatch(ToastChange({ active: true, content: msg }));
    //     navigate("/magazine/list");
    //   }
    // });
  }, []);

  const InsertMagazine = useCallback(
    (template: string) => {
      PostMagazine(MagazineDataCHange(state, template));
    },
    [PostMagazine, state]
  );

  const ExtraMagazine = useCallback(
    (template: string | undefined) => {
      SaveMagazine(
        MagazineDataCHange(state, template ? template : "zxcasdasd")
      );
    },
    [SaveMagazine, state]
  );
  const DetailMagazine = useCallback((id: string) => {
    officeApi
      .get(`/web/cmnt/2/ctts/${id}`)
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          dispatch({
            type: "dispatch/all",
            payload: MagazineBasicDataCHange(succ_obj),
            index: undefined,
          });
        }
      });
  }, []);

  useEffect(() => {
    sessionStorage.setItem("write", JSON.stringify(state));
    return () => {};
  }, [state]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("write");
    };
  }, []);
  useEffect(() => {
    const { name, id } = leaderInfo;
    dispatch({
      type: "leader/info",
      payload: {
        name,
        id,
      },
      index: undefined,
    });
    return () => {};
  }, [leaderInfo]);

  useLayoutEffect(() => {
    const data = sessionStorage.getItem("write");
    if (data) {
      dispatch({
        type: "dispatch/all",
        payload: JSON.parse(data),
        index: undefined,
      });
    } else if (location.state?.ctts_id) {
      DetailMagazine(location.state?.ctts_id);
    }

    return () => {};
  }, [location.state?.ctts_id, DetailMagazine, dispatch]);
  return (
    <main className="write-project" id="wirte-project">
      <div
        className="wrapper"
        style={
          path === "step5"
            ? {
                paddingTop: "165px",
              }
            : undefined
        }
      >
        <div className="write-header">
          <div className="left">
            <div className="title">매거진 작성하기</div>
            <div className="step-wrapper">
              {nav_layouts.map(({ title, path }, idx) => {
                return (
                  <div
                    className={path === location.pathname ? "nav-active" : ""}
                    key={idx}
                  >
                    0{idx + 1} {title}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <Outlet
          context={{
            state,
            dispatch,
            isError,
            UpdateCommon,
            Insert: InsertMagazine,
            setIsLook,
            Save: ExtraMagazine,
            status: location.state && location.state.ctts_sts ? "fix" : "new",
          }}
        />
        {Number(path) < 2 ? (
          <Interaction
            path={Number(path)}
            type={location.state ? "fix" : "new"}
            setisError={setisError}
            valid={Valid}
            Save={ExtraMagazine}
            data={location.state}
          />
        ) : undefined}
        <LookMagazine isLook={isLook} data={state} Cancel={setIsLook} />
      </div>
    </main>
  );
}

export default WriteMagazine;

const nav_layouts = [
  {
    title: "기본정보",
    path: "/magazine/write/step/1",
  },
  {
    title: "상세내용",
    path: "/magazine/write/step/2",
  },
];
